import type { InstantConfigResponse } from "./types";

type QueryValue = boolean | string | string[] | number | number[] | object;

function parseValue(value: string): QueryValue {
  if (value === "true" || value === "false") {
    return value === "true";
  }

  const intValue = parseInt(value, 10);
  if (value === `${intValue}`) {
    return intValue;
  }

  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}

export function override(
  config: InstantConfigResponse,
  queryString: URLSearchParams,
): InstantConfigResponse {
  return [...queryString.keys()]
    .filter(
      (paramKey: string) =>
        paramKey.startsWith("icbm__") && queryString.get(paramKey) !== null,
    )
    .map((paramKey) => {
      const [, key] = paramKey.split("__");

      return {
        key,
        value: parseValue(queryString.get(paramKey)!),
      };
    })
    .reduce(
      (newConfig, { key, value }) => ({ ...newConfig, [key]: value }),
      config,
    );
}
